package com.nnod.ui.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import io.github.goquati.qr.QrCode
import io.github.goquati.qr.QrCode.Ecc

@Composable
fun NnodQrCode(
    payload: String,
    size: Dp = 240.dp,
    modifier: Modifier = Modifier,
) {
    val qrCode = remember(payload) { QrCode.encodeText(payload, Ecc.MEDIUM) }

    Canvas(
        modifier = modifier
            .size(size)
            .background(Color.White),
    ) {
        val renderedModules = qrCode.size + QuietZoneModules * 2
        val canvasSize = this.size
        val cellSize = minOf(canvasSize.width, canvasSize.height) / renderedModules
        val left = (canvasSize.width - cellSize * renderedModules) / 2f
        val top = (canvasSize.height - cellSize * renderedModules) / 2f

        drawRect(Color.White)

        for (y in 0 until qrCode.size) {
            for (x in 0 until qrCode.size) {
                if (qrCode[x, y]) {
                    drawRect(
                        color = Color.Black,
                        topLeft = Offset(
                            x = left + (x + QuietZoneModules) * cellSize,
                            y = top + (y + QuietZoneModules) * cellSize,
                        ),
                        size = Size(cellSize, cellSize),
                    )
                }
            }
        }
    }
}

private const val QuietZoneModules = 4
